import {Button} from 'react-bootstrap';

function IminioButton({ label, color, textColor, onClick = ()=>{}, size, icon, disabled, loading }) {

    // useState ?
    // useRef ?

    return <>
        <Button className={`iminio-button px-3 corner-round ${color} ${textColor} text-9`} disabled={disabled} loading={''+disabled} variant="orange" onClick={onClick} size={'sm'}>
            {loading ? 
                <i className="mdi mdi-loading mdi-spin text-9 fg-white"></i> 
                :
                ( 
                    <>
                        {!icon ? '' :  <i className={`${icon} text-10 ${label? 'me-2' : ''}`}></i>}
                        {label}
                    </>
                )
            }
        </Button>
    </>;
}

export default IminioButton